import UtilService from "../services/util.service";

export default class BotAnalyticsService {
    
    static startChatSuccess(key, pageName, mobilenumber, Circle, platform) {
        // console.log('track start chat success',{key,pageName,mobilenumber,Circle,platform})
        if (key ===  "start_chat_success") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.platform = platform;
            window.sessionID = UtilService.generateUniqueSessionId();
            window._satellite.track("chatbot");
        }
    }

    static startChatFail(key, pageName, mobilenumber) {
        // console.log('track start chat fail',{key, pageName, mobilenumber})
        if (key ===  "start_chat_fail") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            if (window.scenario) {
                delete window.scenario;
            }
            window._satellite.track("chatbot");
        }
    }

    static loginSuccess(key, pageName, mobileNumber, Circle, otp, Scenario) {
        // console.log('track login success',{key, pageName, mobileNumber, Circle, otp, Scenario})
        if (key ===  "login_success") {
            window.my_data = key;
            window.mobileNumber = mobileNumber;
            window.circle = Circle;
            window.scenario = Scenario;
            window.loginType = otp;
            window._satellite.track("chatbot");
        }
    }

    static loginFail(key, pagename, mobilenumber, Circle, Scenario) {
        // console.log('track login fail',{key, pagename, mobilenumber, Circle, Scenario})
        window.mobileNumber = mobilenumber;
        window.circle = Circle;
        window.scenario = Scenario;
        if (window.scenario ===  "chatbot_greeting") {
            delete window.scenario;
        }
        window.my_data = "login_fail";

        window._satellite.track("chatbot");
    }

    static trackSecondaryMobileNumber(key, mobilenumber, secondaryMobileNo, isPrimaryMN, Scenario, optionSelected, Circle) {
        // console.log('track secondary mobile number',{key, mobilenumber, secondaryMobileNo, isPrimaryMN, Scenario, optionSelected, Circle})
        const option = optionSelected.replace(/&#32;/g, " ");
        if (key ===  "secondary_mobileNumber") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.secondaryMN = secondaryMobileNo;
            window.primaryMN = isPrimaryMN;
            window.circle = Circle;
            window.scenario = Scenario;
            window.optionSelected = option;
            window._satellite.track("chatbot");
        }
    }

    static trackPrimaryMobileNumber(key, pagename, mobilenumber, Circle, Scenario, isPrimaryMN, optionSelected) {
        // console.log('track primary mobile  number',{key, pagename, mobilenumber, Circle, Scenario, isPrimaryMN, optionSelected})
        const option = optionSelected.replace(/&#32;/g, " ");
        if (key ===  "primary_mobileNumber") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.scenario = Scenario;
            window.primaryMN = isPrimaryMN;
            window.optionSelected = option;
            window._satellite.track("chatbot");
        }
    }

    static faqQuery(key, pagename, mobilenumber, Circle, Scenario, optionSelected,selectedBy,intentType) {
        // console.log('track faq query',{key, pagename, mobilenumber, Circle, Scenario, optionSelected})
        if (key ===  "faq_query") {
            window.my_data = key;
            window.pageName = pagename;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.scenario = Scenario;
            window.selectedBy = selectedBy;
            window.intentType = intentType
            window.optionSelected = optionSelected;
            window._satellite.track("chatbot");
        }
    }

    static scenarioQuery(key, pagename, mobilenumber, Circle, Scenario, optionSelected) {
        // console.log('track scenario query',{key, pagename, mobilenumber, Circle, Scenario, optionSelected})
        if (key ===  "scenario_query") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.scenario = Scenario;
            window.optionSelected = optionSelected;
            window._satellite.track("chatbot");
        }
    }

    static feedbackSuccess(key, pagename, mobilenumber, Circle, optionSelected, Scenario) {
        // console.log('track feedback success',{key, pagename, mobilenumber, Circle, optionSelected, Scenario})
        if (key ===  "feedback_success") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.optionSelected = optionSelected;
            window.scenario = Scenario;
            window._satellite.track("chatbot");
        }
    }

    static feedbackFail(key, pagename, mobilenumber, Circle, optionSelected, Scenario) {
        // console.log('track feedback fail',{key, pagename, mobilenumber, Circle, optionSelected, Scenario})
        if (key === "feedback_fail") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.optionSelected = optionSelected;
            window.scenario = Scenario;
            window._satellite.track("chatbot");
        }
    }

    static feedbackSkipped(key, pagename, mobilenumber, Circle, optionSelected, Scenario,intentType,selectedBy,sad_skipped) {
        // console.log('track feedback skipped',{key, pagename, mobilenumber, Circle, optionSelected, Scenario})
        if (key === "feedback_skipped") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.optionSelected = optionSelected;
            window.scenario = Scenario;
            window.intentType = intentType;
            window.selectedBy = selectedBy
            window.feedbackSuggestion = sad_skipped;
            window._satellite.track("chatbot");
        }
    }

    static feedbackNotGiven(key, pagename, mobilenumber, Circle, Scenario, optionSelected) {
        // console.log('track feedback not given',{key, pagename, mobilenumber, Circle, Scenario, optionSelected})
        if (key === "feedback_not_given") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.scenario = Scenario;
            window.optionSelected = optionSelected;
            window._satellite.track("chatbot");
        }
    }

    static scenarioFeedbackSuccess(key, pagename, mobilenumber, Circle, optionSelected, Scenario) {
        // console.log('track scenario_feedback_success',{key, pagename, mobilenumber, Circle, optionSelected, Scenario})
        if (key === "scenario_feedback_success") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            optionSelected = optionSelected;
            window.scenario = Scenario;
            window._satellite.track("chatbot");
        }
    }

    static scenarioFeedbackFail(key, pagename, mobilenumber, Circle, optionSelected, Scenario) {
        // console.log('track scenario_feedback_fail ',{key, pagename, mobilenumber, Circle, optionSelected, Scenario})
        if (key === "scenario_feedback_fail") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.optionSelected = optionSelected;
            window.scenario = Scenario;
            window._satellite.track("chatbot");
        }
    }

    static scenarioFeedbackSkipped(key, pagename, mobilenumber, Circle, optionSelected, Scenario) {
        // console.log('track scenario_feedback_skipped',{key, pagename, mobilenumber, Circle, optionSelected, Scenario})
        if (key === "scenario_feedback_skipped") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.optionSelected = optionSelected;
            window.scenario = Scenario;
            window._satellite.track("chatbot");
        }
    }

    static scenarioFeedbackNotGiven(key, pagename, mobilenumber, Circle, Scenario, optionSelected) {
        if (key === "scenario_feedback_not_given") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.scenario = Scenario;
            window.optionSelected = optionSelected;
            window._satellite.track("chatbot");
        }
    }

    static closeChatYes(key, pageName, mobilenumber, Circle, sessionTime, Scenario, queryCount, optionSelected) {
        // console.log('track close chat yes',{key, pageName, mobilenumber, Circle, sessionTime, Scenario, queryCount, optionSelected})
        if (key === "close_chat_yes") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.sessionTime = sessionTime;
            window.scenario = Scenario;
            window.queryCount = queryCount;
            window.optionSelected = optionSelected;
            window._satellite.track("chatbot");
        }
    }

    static closeChatNo(key, pageName, mobilenumber, Circle, sessionTime, Scenario, queryCount, optionSelected) {
        // console.log('track close_chat_no',{key, pageName, mobilenumber, Circle, sessionTime, Scenario, queryCount, optionSelected})
        if (key === "close_chat_no") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.sessionTime = sessionTime;
            window.scenario = Scenario;
            window.queryCount = queryCount;
            window.optionSelected = optionSelected;
            window._satellite.track("chatbot");
        }
    }

    static trackSsoProfileSingle = ( key, mobileNumber, age, numberType , loginType , circle, scenario, selectedBy, optionSelected, intentType, platform) => {
        // console.log('track sso profile single',{key, mobileNumber, age, numberType , loginType , circle, scenario, selectedBy, optionSelected, intentType, platform})
        if(key === 'sso_profile_single'){
          window.mobileNumber= mobileNumber;
          window.age = age;
          window.numberType= numberType;
          window.loginType = loginType;
          window.circle = circle;
          window.scenario = scenario;
          window.selectedBy = selectedBy;
          window.optionSelected = optionSelected;
          window.intentType = intentType;
          window.platform = platform;
          window._satellite.track("chatbot");
        }
    }

    static trackSsoProfileMultiple = (key, mobileNumber, age, numberType , loginType , circle, scenario, selectedBy, optionSelected, intentType, platform) => {
        // console.log('track sso profile multiple',{key, mobileNumber, age, numberType , loginType , circle, scenario, selectedBy, optionSelected, intentType, platform})
        if(key === 'sso_profile_multiple'){
          window.my_data = key;
          window.mobileNumber= mobileNumber;
          window.age = age;
          window.numberType= numberType;
          window.loginType = loginType;
          window.circle = circle;
          window.scenario = scenario;
          window.selectedBy = selectedBy;
          window.optionSelected = optionSelected;
          window.intentType = intentType;
          window.platform = platform;
          window._satellite.track("chatbot");
        }
      }

    static trackSsoProfileNoAccount = ( key, mobileNumber, age, numberType , loginType , circle, scenario, selectedBy, optionSelected, intentType, platform) => {
        // console.log('track sso_profile_no_account',{key, mobileNumber, age, numberType , loginType , circle, scenario, selectedBy, optionSelected, intentType, platform})
        if(key === 'sso_profile_no_account'){
          window.my_data=key;
          window.mobileNumber= mobileNumber;
          window.age = age;
          window.numberType= numberType;
          window.loginType = loginType;
          window.circle = circle;
          window.scenario = scenario;
          window.selectedBy = selectedBy;
          window.optionSelected = optionSelected;
          window.intentType = intentType;
          window.platform = platform;
          window._satellite.track("chatbot");
        }
    }
    static intentReadingSuccess(key, pageName, mobilenumber, Circle, optionSelected, Scenario, intentType, enteredTextMode) {
        // console.log('track intent reading success',{key, pageName, mobilenumber, Circle, optionSelected, Scenario, intentType, enteredTextMode})
        const option = optionSelected.replace(/&#32;/g, " ");
        if (key === "intent_reading_success") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.optionSelected = option;
            window.scenario = Scenario;
            window.intentType = intentType;
            window.feedbackSuggestion = undefined;
            window.selectedBy = enteredTextMode;
            window._satellite.track("chatbot");
            delete window.intentType;
            delete window.selectedBy;
        }
    }

    static intentReadingFail(key, pagename, mobilenumber, Circle, sessionTime, Scenario, optionSelected, enteredTextMode) {
        // console.log('track intent_reading_fail',{key, pagename, mobilenumber, Circle, sessionTime, Scenario, optionSelected, enteredTextMode})
        const option = optionSelected.replace(/&#32;/g, " ");
        if (key === "intent_reading_fail") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.sessionTime = sessionTime;
            delete window.scenario;
            delete window.intentType;
            window.optionSelected = option;
            window.selectedBy = enteredTextMode;
            window._satellite.track("chatbot");
            delete window.optionSelected;
            delete window.selectedBy;
        }
    }

    static ssoProfileSuccess(key, pageName, Circle, mobilenumber, Scenario, optionSelected) {
        const option = optionSelected.replace(/&#32;/g, " ");
        if (key === "sso_profile_success") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.scenario = Scenario;
            window.optionSelected = option;
            window._satellite.track("chatbot");
        }
    }

    static ssoProfileFail(key, pageName, mobilenumber, Circle, Scenario, optionSelected) {
        const option = optionSelected.replace(/&#32;/g, " ");
        if (key === "sso_profile_fail") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.scenario = Scenario;
            window.optionSelected = option;
            window._satellite.track("chatbot");
        }
    }

    static ssoProfileNumberSelectedSuccess(key, pagename, mobilenumber, ssoNumber, Circle, scenario, optionSelected) {
        const option = optionSelected.replace(/&#32;/g, " ");
        if (key === "sso_profile_number_selected_success") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.ssoNumber = ssoNumber
            window.circle = Circle;
            window.scenario = scenario;
            window.optionSelected = option;
            window._satellite.track("chatbot");
        }
    }

    static ssoProfileNumberSelectedFail(key, pagename, mobilenumber, Circle, sessionTime, scenario, optionSelected) {
        // console.log('track sso profile number selected fail',{key, pagename, mobilenumber, Circle, sessionTime, scenario, optionSelected})
        const option = optionSelected.replace(/&#32;/g, " ");
        if (key ===  "sso_profile_number_selected_fail") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.sessionTime = sessionTime;
            window.scenario = scenario;
            window.optionSelected = option;
            window._satellite.track("chatbot");
        }
    }

    static errorFrontend(key, pagename, mobilenumber, Circle, sessionTime, scenario, errorType, optionSelected) {
        // console.log('track error frontend',{key, pagename, mobilenumber, Circle, sessionTime, scenario, errorType, optionSelected})
        const option = optionSelected.replace(/&#32;/g, " ");
        if (key ===  "error_frontend") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.sessionTime = sessionTime;
            window.scenario = scenario;
            window.errorType = errorType;
            window.optionSelected = option;
            window._satellite.track("chatbot");
        }
    }

    static errorBackend(key, pagename, mobilenumber, circle, scenario, errorType, optionSelected) {
        // console.log('track error backend',{key, pagename, mobilenumber, circle, scenario, errorType, optionSelected})
        const option = optionSelected.replace(/&#32;/g, " ");
        if (key ===  "error_backend") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = circle;
            window.scenario = scenario;
            window.errorType = errorType;
            window.optionSelected = optionSelected;
            window._satellite && window._satellite.track("chatbot");
        }
    }

    static idleChat(key, pagename, mobilenumber, Circle, resp, scenario, optionSelected) {
        // console.log('track idle chat',{key, pagename, mobilenumber, Circle, resp, scenario, optionSelected})
        const option = optionSelected.replace(/&#32;/g, " ");
        if (key ===  "idle_chat") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.resp = resp;
            window.scenario = scenario;
            window.optionSelected = option;
            window._satellite.track("chatbot");
        }
    }

    static retryOption(key, pagename, mobileNumber, Circle, intentType, Scenario) {
        // console.log('track retry option',{key, pagename, mobileNumber, Circle, intentType, Scenario})
        if (key ===  "retry_option") {
            window.my_data = key;
            mobileNumber = mobileNumber;
            window.circle = Circle;
            window.intentType = intentType;
            window.scenario = Scenario;
            window._satellite.track("chatbot");
            delete window.intentType;
        }
    }

    static trackfeedbackSatisfied(key, pagename, mobilenumber, Circle, Scenario, optionSelected) {
        // console.log('track feedback satisfied',{key, pagename, mobilenumber, Circle, Scenario, optionSelected})
        if (key ===  "feedback_satisfied") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.optionSelected = optionSelected;
            window.scenario = Scenario;
            window._satellite.track("chatbot");
        }
    }

    static trackFeedbackHappy(key, pagename, mobilenumber, Circle, Scenario, optionSelected,intentType,selectedBy) {
        // console.log('track feedback happy',{key, pagename, mobilenumber, Circle, Scenario, optionSelected})
        if (key === "feedback_happy") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.optionSelected = optionSelected;
            window.scenario = Scenario;
            window.intentType = intentType;
            window.selectedBy  = selectedBy;
            window._satellite.track("chatbot");
        }
    }

    static trackFeedbackSad(key, pagename, mobilenumber, Circle, Scenario, optionSelected,intentType,selectedBy) {
        // console.log('track feedback sad',{key, pagename, mobilenumber, Circle, Scenario, optionSelected})
        if (key === "feedback_sad") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.optionSelected = optionSelected;
            window.scenario = Scenario;
            window.intentType = intentType;
            window.selectedBy = selectedBy;
            window._satellite.track("chatbot");
            delete window.feedbackType;
            delete window.feedbackSuggestion;
        }
    }

    static trackImproveFeedback(key, pagename, mobilenumber, Circle, Scenario, feedbackSuggestion, feedbackType, intentType, optionSelected,selectedBy) {
        // console.log('track improve feedback',{key, pagename, mobilenumber, Circle, Scenario, feedbackSuggestion, feedbackType, intentType, optionSelected})
        if (key === "improve_feedback") {
            window.my_data = key;
            window.mobileNumber = mobilenumber;
            window.circle = Circle;
            window.optionSelected = optionSelected;
            window.scenario = Scenario;
            window.feedbackType = feedbackType;
            window.feedbackSuggestion = feedbackSuggestion;
            window.intentType = intentType;
            window.selectedBy = selectedBy;
            window. _satellite.track("chatbot");
            delete window.feedbackType;
            delete window.feedbackSuggestion;
            delete window.intentType;
        }
    }

    static trackGridClicks = (key, circle, mobileNumber, scenario, selectedBy, optionSelected, intentType, platform) => {
        // console.log('track grid_clicks',{key, circle, mobileNumber, scenario, selectedBy, optionSelected, intentType, platform})
        if(key == 'grid_clicks'){
          window.my_data=key;
          window.mobileNumber = mobileNumber;
          window.circle = circle;
          window.scenario=scenario;
          window.selectedBy =selectedBy;
          window.optionSelected =optionSelected;
          window.intentType =intentType;
          window.platform =platform;
          window._satellite.track("chatbot");
        }
    }
    static trackLinkClick = (key, mobileNumber, circle, scenario, selectedBy, optionSelected, intentType, platform, numberType) => {
        // console.log('track link_clicks',{key, mobileNumber, circle, scenario, selectedBy, optionSelected, intentType, platform, numberType})
        // SHEKHAR
        if(key == 'link_clicks'){
          window.my_data=key;
          window.linkName=key;
          window.mobileNumber= mobileNumber;
          window.circle = circle;
          window.scenario =scenario;
          window.selectedBy =selectedBy;
          window.optionSelected = optionSelected;
          window.intentType =intentType;
          window.platform =platform;
          window.numberType = numberType;
          window._satellite.track("generic-click");
        }
    }
    static trackSwitchClickPreToPost = (key, mobileNumber,  switchType, circle, scenario, selectedBy, optionSelected, intentType, platform, numberType) => {
        // console.log('track switch_click_pre_to_post',{key, mobileNumber,  switchType, circle, scenario, selectedBy, optionSelected, intentType, platform, numberType})
        if(key == 'switch_click_pre_to_post'){
          window.my_data=key;
          window.linkName = key;
          window.mobileNumber = mobileNumber;
          window.switchType = switchType;
          window.circle = circle;
          window.scenario= scenario;
          window.selectedBy = selectedBy;
          window.optionSelected = optionSelected;
          window.intentType = intentType;
          window.platform = platform;
          window.numberType = numberType;
          window._satellite.track("generic-click");
        }
    }
    static trackSwitchClickPostToPre = (key, mobileNumber,  switchType, circle, scenario, selectedBy, optionSelected, intentType, platform, numberType) => {
        // console.log('track switch_click_post_to_pre',{key, mobileNumber,  switchType, circle, scenario, selectedBy, optionSelected, intentType, platform, numberType})
        if(key == 'switch_click_post_to_pre'){
          window.my_data=key;
          window.linkName = key;
          window.mobileNumber = mobileNumber;
          window.switchType = switchType;
          window.circle = circle;
          window.scenario= scenario;
          window.selectedBy = selectedBy;
          window.optionSelected = optionSelected;
          window.intentType = intentType;
          window.platform = platform;
          window.numberType = numberType;
          window._satellite.track("generic-click");
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/bot-analytics.service.js